// import * as yup from 'yup';

// import { checkSINValidity } from '../../../components/T4Slip/T4SlipSetup/validator';

// export const T4ASlipSetupValidationSchema = yup.object({
//   name1: yup
//     .string().nullable()
//     .when('payeeType', {
//       is: true,
//       then: yup.string().required('First Name is required').max(12, "First Name has at most 12 characters"),
//       otherwise: yup.string().nullable()
//     }),

//   initials: yup.string().max(1, "maximum one character"),

//   name2: yup
//     .string().nullable()
//     .when('payeeType', {
//       is: true,
//       then: yup.string().required('Last Name is required').max(20, "Last Name has at most 20 characters"),
//       otherwise: yup.string().nullable()
//     }),

//   uniqueIdentifier: yup
//     .string().nullable()
//     .when('payeeType', {
//       is: true,
//       then: yup.string().test(
//         'is-masked-or-not',
//         'Invalid value',
//         function (value:any) {
//           let sin = value && value.replace(/-/g, '')
//           const output = checkSINValidity(sin);

//           let maxLength = 11;

//           if (value && value.charAt(2) === '*') {
//             maxLength = 7;
//             if (value && value.length == maxLength) {
//               return true;
//             } else {
//               return this.createError({
//                 message: 'Invalid Social Insuarance Number',
//                 path: this.path,
//               });
//             }
//           } else {
//             if (value && value.length == maxLength && output % 10 === 0) {
//               return true;
//             } else {
//               return this.createError({
//                 message: 'Invalid Social Insuarance Number',
//                 // message: 'Social Insuarance Number has at least 9 characters',
//                 path: this.path,
//               });
//             }
//           }
//         }
//       ).required('Social Insuarance is required'),
//       otherwise: yup.string().nullable()
//     }),

//   businessName: yup.string().nullable()
//   .when('payeeType', {
//     is: false,
//     then: yup.string().nullable().required('business Name is required'),
//     otherwise: yup.string().nullable()
//   }),

//   // businessNumber: yup.string().nullable()
//   // .when('payeeType', {
//   //   is: false,
//   //   then: yup.string().test('isRequired', 'Business Number is required', value => {
//   //     return value !== undefined && value !== null && value.trim() !== '';
//   //   }),
//   //   otherwise: yup.string().nullable()
//   // }),
//   businessNumber: yup.string().nullable()
//   .when('payeeType', {
//     is: false,
//     then: yup.string().test(
//       'is-valid-or-not',
//       'Invalid value',
//       function (value:any) {
//         let maxLength = 15;

//         const firstNineDigits: string = value && value.substring(0, 9);

//         const output = checkSINValidity(firstNineDigits);

//           if (value && value.length == maxLength && output % 10 === 0) {
//             return true;
//           } else {
//             return this.createError({
//               message: 'Invalid Business Number',
//               path: this.path,
//             });
//           }
//       }
//     ).nullable().required('business Number is required'),
//     otherwise: yup.string().nullable()
//   }),

//   addressLine1: yup
//     .string()
//     .required("Address is required")
//     .max(50, "Address has at most 50 characters"),

//   city: yup
//     .string()
//     .required("City is required")
//     .max(28, "City has at most 28 characters"),

//   province: yup.string().nullable().required("Province is required"),

//   postalCode: yup
//     .string()
//     .required("PostCode is required")
//     .max(10, "Post Code has at most 10 characters"),

//   country: yup.mixed().test(
//     'is-string-or-object',
//     'Input must be a string or an object.',
//     (value) => typeof value === 'string' || typeof value === 'object'
//   ).required("Country is required"),

//   slipType: yup.number().required("slipType is required"),

//   slipStatus: yup.number().required("slip Status is required"),

//   email: yup
//     .string().nullable()
//     .email("Please enter valid Email"),
// });

// with v20.12.21

import * as yup from "yup";

import { checkSINValidity } from "../../../common/Common";

export const T4ASlipSetupValidationSchema = yup.object({
  // name1: yup
  //   .string()
  //   .nullable()
  //   .when("payeeType", (payeeType: any, schema) => {
  //     if (payeeType === true) {
  //       return schema
  //         .required("First Name is required")
  //         .max(12, "First Name has at most 12 characters");
  //     }
  //     return schema.nullable();
  //   }),

  // initials: yup.string().max(1, "Maximum one character"),

  // name2: yup
  //   .string()
  //   .nullable()
  //   .when("payeeType", (payeeType: any, schema) => {
  //     if (payeeType === true) {
  //       return schema
  //         .required("Last Name is required")
  //         .max(20, "Last Name has at most 20 characters");
  //     }
  //     return schema.nullable();
  //   }),

  // uniqueIdentifier: yup
  //   .string()
  //   .nullable()
  //   .when("payeeType", (payeeType: any, schema) => {
  //     if (payeeType === true) {
  //       return schema
  //         .test(
  //           "is-masked-or-not",
  //           "Invalid Social Insurance Number",
  //           function (value: any) {
  //             if (!value) {
  //               return this.createError({
  //                 message: "Social Insurance Number is required",
  //                 path: this.path,
  //               });
  //             }

  //             const sin = value.replace(/-/g, "");
  //             const output = checkSINValidity(sin);
  //             let maxLength = 11;

  //             // Handle masked SIN like "**1234"
  //             if (value.charAt(2) === "*") {
  //               maxLength = 7;
  //               if (value.length === maxLength) return true;
  //               return this.createError({
  //                 message: "Invalid Social Insurance Number",
  //                 path: this.path,
  //               });
  //             }

  //             // Normal SIN validation
  //             if (value.length === maxLength && output % 10 === 0) return true;

  //             return this.createError({
  //               message: "Invalid Social Insurance Number",
  //               path: this.path,
  //             });
  //           }
  //         )
  //         .required("Social Insurance Number is required");
  //     }
  //     return schema.nullable();
  //   }),

  // businessName: yup
  //   .string()
  //   .nullable()
  //   .when("payeeType", (payeeType: any, schema) => {
  //     if (payeeType === false) {
  //       return schema.required("Business Name is required");
  //     }
  //     return schema.nullable();
  //   }),

  // businessNumber: yup
  //   .string()
  //   .nullable()
  //   .when("payeeType", (payeeType: any, schema) => {
  //     if (payeeType === false) {
  //       return schema
  //         .test(
  //           "is-valid-or-not",
  //           "Invalid Business Number",
  //           function (value: any) {
  //             if (!value) {
  //               return this.createError({
  //                 message: "Business Number is required",
  //                 path: this.path,
  //               });
  //             }

  //             const maxLength = 15;
  //             const firstNineDigits = value.substring(0, 9);
  //             const output = checkSINValidity(firstNineDigits);

  //             if (value.length === maxLength && output % 10 === 0) {
  //               return true;
  //             }

  //             return this.createError({
  //               message: "Invalid Business Number",
  //               path: this.path,
  //             });
  //           }
  //         )
  //         .required("Business Number is required");
  //     }
  //     return schema.nullable();
  //   }),

  // addressLine1: yup
  //   .string()
  //   .required("Address is required")
  //   .max(50, "Address has at most 50 characters"),

  // city: yup
  //   .string()
  //   .required("City is required")
  //   .max(28, "City has at most 28 characters"),

  // province: yup.string().nullable().required("Province is required"),

  // postalCode: yup
  //   .string()
  //   .required("Post Code is required")
  //   .max(10, "Post Code has at most 10 characters"),

  // country: yup
  //   .mixed()
  //   .test(
  //     "is-string-or-object",
  //     "Input must be a string or an object.",
  //     (value) => typeof value === "string" || typeof value === "object"
  //   )
  //   .required("Country is required"),

  // slipType: yup.number().required("Slip Type is required"),

  // slipStatus: yup.number().required("Slip Status is required"),

  // email: yup.string().nullable().email("Please enter a valid Email"),

  name1: yup
    .string()
    .test(
      "is-required-if-individual",
      "First Name is required",
      function (value) {
        const { payeeType } = this.parent;
        if (payeeType === true && (!value || value.trim() === "")) {
          return this.createError({
            message: "First Name is required",
            path: this.path,
          });
        }
        return true;
      }
    )
    .max(12, "First Name has at most 12 characters")
    .nullable(),

  initials: yup.string().max(1, "Maximum one character"),

  name2: yup
    .string()
    .test(
      "is-required-if-individual",
      "Last Name is required",
      function (value) {
        const { payeeType } = this.parent;
        if (payeeType === true && (!value || value.trim() === "")) {
          return this.createError({
            message: "Last Name is required",
            path: this.path,
          });
        }
        return true;
      }
    )
    .max(20, "Last Name has at most 20 characters")
    .nullable(),

  uniqueIdentifier: yup
    .string()
    .test(
      "is-valid-sin-or-masked",
      "Invalid Social Insurance Number",
      function (value: any) {
        const { payeeType } = this.parent;
        if (payeeType) {
          if (!value) {
            return this.createError({
              message: "Social Insurance Number is required",
              path: this.path,
            });
          }

          const sin = value.replace(/-/g, "");
          const output = checkSINValidity(sin);
          let maxLength = 11;

          // Masked SIN like **1234
          if (value.charAt(2) === "*") {
            maxLength = 7;
            if (value.length === maxLength) return true;
            return this.createError({
              message: "Invalid Social Insurance Number",
              path: this.path,
            });
          }

          if (value.length === maxLength && output % 10 === 0) return true;

          return this.createError({
            message: "Invalid Social Insurance Number",
            path: this.path,
          });
        }
        // else {
        //   if (!value) {
        //     return true;
        //   }

        //   const sin = value.replace(/-/g, "");
        //   const output = checkSINValidity(sin);
        //   let maxLength = 11;

        //   // Masked SIN like **1234
        //   if (value.charAt(2) === "*") {
        //     maxLength = 7;
        //     if (value.length === maxLength) return true;
        //     return this.createError({
        //       message: "Invalid Social Insurance Number",
        //       path: this.path,
        //     });
        //   }

        //   if (value.length === maxLength && output % 10 === 0) return true;

        //   return this.createError({
        //     message: "Invalid Social Insurance Number",
        //     path: this.path,
        //   });
        // }
        return true;
      }
    )
    .nullable(),

  businessName: yup
    .string()
    .test(
      "is-required-if-business",
      "Business Name is required",
      function (value) {
        const { payeeType } = this.parent;
        if (payeeType === false && (!value || value.trim() === "")) {
          return this.createError({
            message: "Business Name is required",
            path: this.path,
          });
        }
        return true;
      }
    )
    .nullable(),

  businessNumber: yup
    .string()
    .test(
      "is-valid-business-number",
      "Invalid Business Number",
      function (value: any) {
        const { payeeType } = this.parent;
        // if (payeeType) {
        //   if (!value) {
        //     return true
        //   }

        //   const maxLength = 15;
        //   const firstNineDigits = value.substring(0, 9);
        //   const output = checkSINValidity(firstNineDigits);

        //   if (value.length === maxLength && output % 10 === 0) {
        //     return true;
        //   }

        //   return this.createError({
        //     message: "Invalid Business Number",
        //     path: this.path,
        //   });
        // } else
        if (!payeeType) {
          if (!value) {
            return this.createError({
              message: "Business Number is required",
              path: this.path,
            });
          }

          const maxLength = 15;
          const firstNineDigits = value.substring(0, 9);
          const output = checkSINValidity(firstNineDigits);

          if (value.length === maxLength && output % 10 === 0) {
            return true;
          }

          return this.createError({
            message: "Invalid Business Number",
            path: this.path,
          });
        }
        return true;
      }
    )
    .nullable(),

  addressLine1: yup
    .string()
    .required("Address is required")
    .max(50, "Address has at most 50 characters"),

  city: yup
    .string()
    .required("City is required")
    .max(28, "City has at most 28 characters"),

  province: yup.string().nullable().required("Province is required"),

  postalCode: yup
    .string()
    .required("Post Code is required")
    .max(10, "Post Code has at most 10 characters"),

  country: yup
    .mixed()
    .test(
      "is-string-or-object",
      "Input must be a string or an object.",
      (value) => typeof value === "string" || typeof value === "object"
    )
    .required("Country is required"),

  slipType: yup.number().required("Slip Type is required"),

  slipStatus: yup.number().required("Slip Status is required"),

  email: yup.string().nullable().email("Please enter a valid Email"),

  saskatchewanPensionPlanSpousalContributorSin: yup
    .string()
    .notRequired() // ⬅ Skip validation when empty
    .test(
      "is-valid-sin",
      "Invalid Social Insurance Number",
      function (value: any) {
        // ⬅ If field is empty → valid, no validation needed
        if (!value || value.trim() === "") return true;

        const sin = value.replace(/-/g, "");
        const output = checkSINValidity(sin);
        let maxLength = 11;

        // // Masked SIN like **1234
        // if (value.charAt(2) === "*") {
        //   maxLength = 7;
        //   if (value.length === maxLength) return true;

        //   return this.createError({
        //     message: "Invalid Social Insurance Number",
        //     path: this.path,
        //   });
        // }

        if (value.length === maxLength && output % 10 === 0) return true;

        return this.createError({
          message: "Invalid Saskatchewan SIN",
          path: this.path,
        });
      }
    )
    .nullable(),

  employerOfferedDentalBenefits: yup
    .string()
    .test(
      "is-required-based-on-pension",
      "Employer Offered Dental Benefits is required",
      function (value) {
        const pension = this.parent?.pensionOrSuperannuation;

        // If pension is null, empty, or "0.00" → no validation needed
        if (
          !pension ||
          pension === "" ||
          pension === "0.00" ||
          pension === "0"
        ) {
          return true; // field optional
        }

        // If pension has value → employerOfferedDentalBenefits is required
        if (value && value.trim() !== "") {
          return true; // valid
        }

        // Throw required error
        return this.createError({
          message: "Employer Offered Dental Benefits is required",
          path: this.path,
        });
      }
    )
    .nullable(),

  recipientNumber: yup
    .string()
    .max(20, "Recipient number has at most 20 characters")
    .nullable(),
});
